import { bindable, capture } from "aurelia";

@capture((attrs) => attrs !== "id" && attrs !== "label" && attrs !== "disabled" && attrs !== "validate")
export class TextAreaComponent {

  public id: string = crypto.randomUUID();
  private tooltipId: string = crypto.randomUUID();

  @bindable public validate: boolean = false;

  @bindable label: string;
  @bindable helper: string;
  @bindable hint: string;
  @bindable maxLength: number;
  @bindable disabled: boolean = false;

  private inputElement: HTMLInputElement;
  private tooltip: HTMLElement;

  attached() {
    this.inputElement = document.getElementById(this.id) as HTMLInputElement

    if (this.helper)
      this.tooltip = document.getElementById(this.tooltipId) as HTMLElement;
  }

  showTooltip() {
    if (this.tooltip) {
      this.tooltip.classList.add('block')
      this.tooltip.classList.remove('hidden')
    }
  }

  hideTooltip() {
    if (this.tooltip) {
      this.tooltip.classList.add('hidden')
      this.tooltip.classList.remove('block')
    }
  }

}